import { UnitInputValidationTypes, ValidationColors } from './UnitInput.decl';

export function getValidationColor(validationStatus?: UnitInputValidationTypes): string | null {
  return (validationStatus ? ValidationColors[validationStatus] : null) || null;
}
